
import { ExcelMapperConfig } from "@/utils/excel-mapper/excel-mapper-config";
import AppFileUpload from "./ExcelMapperSettingsEditUploadFile.vue";
import AppColumnsEdit from "./ExcelMapperSettingsEditColumns.vue";
import Vue from "vue";
import { ExcelMapperSettings } from "@/models/excel-mapper-settings";
import { ExcelMapperService } from "@/utils/services/excel-mapper-service";
import { createExcelMapperWrapper } from "@/utils/excel-mapper/excel-mapper-wrapper";

export default Vue.extend({
	data(){
		return {
			worksheet: createExcelMapperWrapper(),
			isSaving: false,
		};
	},
	props: {
		allowedOutputHeaders: {
			type: Array as ()=>string[],
			required: true
		},
		settings: {
			type: Object as ()=>ExcelMapperSettings,
			required: true
		},
		service: {
			type: Object as ()=>ExcelMapperService,
			required: true
		}
	},
	computed: {
		knownHeaders():string[] {
			if (!this.worksheet.hasSheet) return [];
			let sheet = this.worksheet.getSheet();
			if (!sheet) return [];
			let result:string[] = [];
			let row = sheet.getRow(this.config.HeaderRow);
			for (let i = 1; i <=  row.cellCount; i++) {
				let val = row.getCell(i).value;
				if (!val) continue;
				result.push(val.toString());
			}
			return result;
		},
		config():ExcelMapperConfig{
			return this.settings.Settings;
		},
		isValid():boolean {
			if (this.config.Cols.length == 0) return false;
			return this.worksheet.hasSheet;
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async saveSettings(){
			if (this.isSaving) return;
			this.isSaving = true;
			try{

				if (this.settings.ID == 0){
					var result = await this.service.createSetting(this.settings);
				}else{
					var result = await this.service.updateSetting(this.settings);
				}
				this.$wf.notify(this.$ct("common.success"), "success", 3000, "check");
				this.$emit("settings", result);
			}catch(err){
			}finally {
				this.isSaving = false;
			}
		}
	},
	components: {
		AppFileUpload,
		AppColumnsEdit
	},
	i18nEx: {
		componentPrefix: "components.excel-mapper"
	}
});
